import { myAppScopeService } from 'v5/services/internal/AppScopeService/AppScopeService.connected';
import { mySystemSettingsService } from './SystemSettingsService.connected';

export function useBrowsingDefaultTimezone(enabled = true) {
  const scope = myAppScopeService.useResolvedScopeIdentity();
  return mySystemSettingsService.useSetting(
    enabled ? scope : undefined,
    'defaults_timezone'
  );
}
